import PropTypes from 'prop-types';
import { get, set, cloneDeep } from 'lodash';
import React, { PureComponent } from 'react';
import { Button, Form, Grid, Row, Col } from 'react-bootstrap/lib';
import Switch from '../inputs/Switch';
import TextInput from '../inputs/TextInput';
import NumberInput from '../inputs/NumberInput';
import ColorPicker from '../inputs/ColorPicker';
import CodeTextArea from '../inputs/CodeTextArea';
import ImageUpload from '../inputs/ImageUpload';
import {
  STANDALONE_TRADEIN_BUTTON_CLASSNAME,
  STANDALONE_PREAPPROVAL_BUTTON_CLASSNAME,
  STANDALONE_BROWSE_BUTTON_CLASSNAME,
  widgetsScriptURL,
} from '../../../util/constants';

const STANDALONE_BUTTON_LIST = [
  {
    buttonType: 'tradeInButton',
    title: 'Standalone TradeIn Button',
    placeholder: 'Value Your Trade',
    containerClassName: STANDALONE_TRADEIN_BUTTON_CLASSNAME,
  },
  {
    buttonType: 'preApprovalButton',
    title: 'Standalone Pre-Approved Button',
    placeholder: 'Get Pre-Approved',
    containerClassName: STANDALONE_PREAPPROVAL_BUTTON_CLASSNAME,
  },
  {
    buttonType: 'browseButton',
    title: 'Standalone Browse Button',
    placeholder: 'Browse',
    containerClassName: STANDALONE_BROWSE_BUTTON_CLASSNAME,
  },
];

class StandaloneButtonsEditor extends PureComponent {
  onChange = (e) => {
    const formData = cloneDeep(this.props.formData);
    set(formData, e.target.name, e.target.value);
    this.props.onChange(formData);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.props.onSave();
  };

  renderStandaloneButtonSection = ({
    title,
    buttonType,
    placeholder,
    containerClassName,
  }) => {
    const { formData } = this.props;
    return (
      <Col sm={6}>
        <h4>{title}</h4>
        <Switch
          name={`${buttonType}.enabled`}
          formData={formData}
          onChange={this.onChange}
        />
        {get(formData, 'useCTAImages') && (
          <ImageUpload
            name={`${buttonType}.image`}
            label="Button Image"
            formData={formData}
            onChange={this.onChange}
          />
        )}
        <TextInput
          name={`${buttonType}.text`}
          label="Button Text"
          formData={formData}
          onChange={this.onChange}
          placeholder={placeholder}
        />
        <NumberInput
          name={`${buttonType}.textSize`}
          label="Button Text Size"
          formData={formData}
          onChange={this.onChange}
          info="Enter value in pixels"
        />
        <ColorPicker
          name={`${buttonType}.backgroundColor`}
          label="Button Background Color"
          formData={formData}
          onChange={this.onChange}
        />
        <ColorPicker
          name={`${buttonType}.textColor`}
          label="Button Text Color"
          formData={formData}
          onChange={this.onChange}
        />
        <CodeTextArea
          label="Button Container"
          value={`<!— Copy this markup into your page template where you want the button to render —>\n<div class="${containerClassName}"></div>`}
        />
      </Col>
    );
  };

  render() {
    const {
      dealer,
      page: { title },
    } = this.props;
    return (
      <Form onSubmit={this.handleSubmit}>
        <Grid fluid>
          <Row>
            <Col sm={12}>
              <h3>{title}</h3>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <div className="widget-text-toggle-group">
                <Switch
                  name="useCTAImages"
                  label="CTA Images Instead of Text"
                  formData={this.props.formData}
                  onChange={this.onChange}
                />
              </div>
            </Col>
          </Row>
          <Row>
            {STANDALONE_BUTTON_LIST.map(this.renderStandaloneButtonSection)}
          </Row>
          <Row>
            <Col sm={12}>
              <h4>Markup</h4>
              <small>
                Copy the markup below into your page template to render these
                buttons. Only add this script once per page.
              </small>
              <CodeTextArea
                label="Agent Script"
                value={`<!— Copy this markup into your page template after the closing <body/> tag —>\n<script src="${widgetsScriptURL}" type="text/javascript" id="prodigyButtonGroupAgent" dealerId="${dealer.id}"></script>`}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Button bsClass="btn btn-primary" type="submit">
                Preview
              </Button>
            </Col>
          </Row>
        </Grid>
      </Form>
    );
  }
}

StandaloneButtonsEditor.propTypes = {
  dealer: PropTypes.object,
  page: PropTypes.object,
  formData: PropTypes.object,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
};

export default StandaloneButtonsEditor;
